import React, { useState } from "react";
import { Button, Tag, message } from "antd";
import aiConsoleService from "services/aiconsoleservice";

// antd v5 primary buttons render transparent under Tailwind Preflight; force the themed fill.
const PRIMARY_BTN = "!bg-[#0b1437] hover:!bg-[#1e293b] !border-[#0b1437] !text-white";

// Only the In-App HR Chat agent has an eval harness wired today (backend returns 422 otherwise).
const EVAL_SUPPORTED = ["inapp_hr_chat"];

const Evaluation = ({ agent }) => {
  const supported = EVAL_SUPPORTED.includes(agent?.agent_key);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setRunning(true);
    try {
      const res = await aiConsoleService.runAgentEval(agent.agent_key);
      setResult(res?.data ?? null);
    } catch (e) {
      message.error("Could not run the evaluation.");
    } finally {
      setRunning(false);
    }
  };

  if (!supported) {
    return (
      <div className="p-10 text-center text-gray-400 dark:text-gray-500" data-testid="eval-unsupported">
        Evaluation is available for the In-App HR Chat agent only.
      </div>
    );
  }

  return (
    <div data-testid="eval-panel" className="max-w-2xl">
      <div className="flex items-center gap-3 mb-4">
        <Button type="primary" className={PRIMARY_BTN} loading={running} onClick={run} data-testid="eval-run">
          Run evaluation
        </Button>
        <span className="text-xs text-gray-400">
          Runs the golden-question set against the live prompt and settings.
        </span>
      </div>

      {result && (
        <div data-testid="eval-result">
          <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 mb-4">
            <div className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Pass rate</div>
            <div className="mt-1 text-2xl font-semibold text-slate-800 dark:text-white">
              {result.pass_rate}%
              <span className="text-sm font-normal text-gray-400 ml-2">
                ({result.passed}/{result.total} passed)
              </span>
            </div>
          </div>

          <ul className="divide-y divide-gray-100 dark:divide-gray-700 rounded-xl border border-gray-200 dark:border-gray-700">
            {(result.results || []).map((r, i) => (
              <li key={i} className="flex items-start justify-between gap-3 px-4 py-2 text-sm" data-testid="eval-question">
                <span className="text-slate-700 dark:text-gray-200 min-w-0">{r.question}</span>
                {r.passed ? (
                  <Tag color="green">PASS</Tag>
                ) : (
                  <Tag color="red">FAIL</Tag>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Evaluation;
